
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import {
  ServicePageHero,
  ServiceProcess,
  ServiceTrust,
  ServiceContact,
} from '../../../components/feature';
import { MOLD_REMOVAL_DATA, SERVICE_FORM_ENDPOINT } from '../../../data/servicePageData';

export default function MoldRemovalPage() {
  const { title, subtitle, heroImage, processTitle, processSubtitle, steps } = MOLD_REMOVAL_DATA;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicePageHero title={title} subtitle={subtitle} backgroundImage={heroImage} />
      <ServiceProcess title={processTitle} subtitle={processSubtitle} steps={steps} />
      <ServiceTrust serviceName="Mold Removal" />
      <ServiceContact serviceName="Mold Removal" formEndpoint={SERVICE_FORM_ENDPOINT} />
      <Footer />
    </div>
  );
}
